import { observable } from "mobx";
import { Type } from "class-transformer";
import ExemptionChangeOrigin from "./exemptionChangeOrigin";
import ExemptionPropertyChangeDisplayType from "./exemptionPropertyChangeDisplayType";
import VehicleRegisterVehicleChange from "./vehicleRegisterVehicleChange";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ExemptionChangeResponse {
  /**
   * Changed at.
   */
  @observable
  @Type(() => Date)
  changedAt!: Date;

  @observable
  changeType!: ExemptionPropertyChangeDisplayType;

  /**
   * Original value, only specified for changes other than vehicle parameters or vehicle ID change.
   */
  @observable
  originalValue?: string;

  /**
   * New value, only specified for changes other than vehicle parameters or vehicle ID change.
   */
  @observable
  newValue?: string;

  @observable
  @Type(() => VehicleRegisterVehicleChange)
  originalVehicleRegisterVehicle?: VehicleRegisterVehicleChange;

  @observable
  @Type(() => VehicleRegisterVehicleChange)
  newVehicleRegisterVehicle?: VehicleRegisterVehicleChange;

  /**
   * Changed by.
   */
  @observable
  changedBy?: string;

  @observable
  changeOrigin!: ExemptionChangeOrigin;

  @observable
  _showDetail: boolean = true;
}
